export default __webpack_public_path__ + "assets/floor.c921389f.svg";